import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import App from './App';

const container = document.getElementById('root');
const app = (
  <HelmetProvider>
    <App />
  </HelmetProvider>
);

// The postbuild prerender script (scripts/prerender.js) fills #root with
// static markup for crawlers; hydrate it instead of re-rendering from
// scratch so the prerendered content isn't discarded and re-created.
if (container.hasChildNodes()) {
  hydrateRoot(container, app);
} else {
  createRoot(container).render(app);
}
